/**
 * Teaching Suite — 15 tools for educators.
 * 14 LIVE + 1 coming-soon (PPT-to-Quiz needs file upload).
 */
import { GraduationCap, FileText, BookOpen, LayoutGrid, ClipboardList,
  CalendarCheck, Award, Network, Library, FileQuestion, Clock,
  Target, Brain, PenTool, Sparkles, Mail, Layers,
} from "lucide-react";
import SuiteHub from "@/components/premium/SuiteHub";

const SECTIONS = [
  {
    title: "AI Assistant (featured)",
    tools: [
      { name: "Teaching AI Assistant", desc: "Upload PDF/PPT → Lesson Plan + Quiz + Homework in 1 click", Icon: Sparkles, to: "/teaching/ai-assistant", badge: "NEW" },
    ],
  },
  {
    title: "Lesson & content",
    tools: [
      { name: "AI PPT Generator", desc: "Topic → editable PPTX in 1 minute", Icon: GraduationCap, to: "/tools/ai-slides", badge: "LIVE" },
      { name: "Lesson Planner", desc: "Topic + grade → 45-min lesson plan", Icon: BookOpen, to: "/teaching/lesson-planner", badge: "LIVE" },
      { name: "Teaching Notes", desc: "Chapter → teacher-ready notes", Icon: PenTool, to: "/teaching/teaching-notes", badge: "LIVE" },
      { name: "Study Material", desc: "Topic → student handout", Icon: Library, to: "/teaching/study-material", badge: "LIVE" },
      { name: "Mind Map Generator", desc: "Topic → hierarchical mind map", Icon: Network, to: "/teaching/mind-map", badge: "LIVE" },
    ],
  },
  {
    title: "Assessment & quizzes",
    tools: [
      { name: "Question Paper", desc: "MCQ + subjective + answer key", Icon: ClipboardList, to: "/teaching/question-paper", badge: "LIVE" },
      { name: "Question Bank", desc: "30-100 questions with difficulty labels", Icon: FileQuestion, to: "/teaching/question-bank", badge: "LIVE" },
      { name: "Worksheet Generator", desc: "Grade-appropriate print-ready", Icon: FileText, to: "/teaching/worksheet", badge: "LIVE" },
      { name: "Rubric Generator", desc: "Assignment → 4-level rubric", Icon: Target, to: "/teaching/rubric", badge: "LIVE" },
      { name: "Flashcard Generator", desc: "Spaced-repetition cards", Icon: LayoutGrid, to: "/teaching/flashcards", badge: "LIVE" },
      { name: "PPT to Quiz", desc: "Upload .pptx → instant quiz", Icon: FileText, to: "/teaching/ppt-to-quiz", badge: "LIVE" },
    ],
  },
  {
    title: "Homework & operations",
    tools: [
      { name: "Homework Generator", desc: "Multi-day homework with parent notes", Icon: Clock, to: "/teaching/homework", badge: "LIVE" },
      { name: "Assignment Generator", desc: "Project-based assignments", Icon: Brain, to: "/teaching/assignment", badge: "LIVE" },
      { name: "Parent Communication", desc: "Emails, WhatsApp notes, PTA scripts + Hindi", Icon: Mail, to: "/teaching/parent-communication", badge: "NEW" },
      { name: "Course Outline", desc: "Multi-week course planner with milestones", Icon: Layers, to: "/teaching/course-outline", badge: "NEW" },
      { name: "Attendance Sheet", desc: "Class roster → printable monthly sheet", Icon: CalendarCheck, to: "/teaching/attendance", badge: "LIVE" },
      { name: "Certificate Generator", desc: "Branded certificates in bulk", Icon: Award, to: "/teaching/certificate", badge: "LIVE" },
    ],
  },
];

export default function PremiumTeachingSuite() {
  return (
    <SuiteHub
      testId="teaching-suite"
      eyebrow="Teaching Suite"
      title="Every classroom workflow — automated"
      subtitle="From lesson planning to certificates. Save 10+ hours per week."
      sections={SECTIONS}
    />
  );
}
